'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alias = require('./alias');

var _alias2 = _interopRequireDefault(_alias);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TableRow = (0, _alias2.default)('tr', 'TableRow'); /**
                                                        * Alias for the tr tag. The TableRow element defines a row of a Table.
                                                        *
                                                        * @module TableRow
                                                        * @func
                                                        * @since 1.0.0
                                                        * @param {Object} props
                                                        */

exports.default = TableRow;